/**
 * 缓存命名规范
 */
enum UserEnum {
  NAME = 'user',
  // 用户详情
  USER_INFO = 'user_info',
  // 用户token
  TOKEN = 'token',
}
export default UserEnum;
